export const complications: any = {
  "#F87E7E": "Implants",
  "#C7C7C7": "Ankylosed",
  "#A5D893": "Impacted",
  "#FFAB5D": "Unerrupted",
  "#63B4FF": "DoNotMove",
  "#f1bec7": "Crown / veneer / lamination",
  "#00C7B1": "Bridge",
};
